
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.384 0H.616A.616.616 0 000 .616v19.781c0 .34.276.616.616.616h13.768c.34 0 .616-.276.616-.616V.616A.616.616 0 0014.384 0zm-4.023 1.231v1.744H4.639V1.23h5.722zm3.408 18.55H1.23V1.231h2.177v2.36c0 .34.276.615.616.615h6.952c.34 0 .616-.276.616-.616V1.231h2.177v18.55z"}}),_c('path',{attrs:{"d":"M11.55 9.018H9.18c-.817.033-.816 1.2 0 1.231h.884l-2.913 2.913-1.893-1.893a.616.616 0 00-.871 0L3.014 12.64c-.554.6.271 1.425.87.871l.938-.937 1.894 1.893a.62.62 0 00.87 0l3.349-3.348v.884c.032.817 1.199.816 1.23 0v-2.37a.616.616 0 00-.615-.616z"}})])
          )
        }
      }
    